import { useDesignMaxTheme } from "@/packages";
import { type RoomDMaxInfoResponse } from "@/shared/server";
import { Box, Center, chakra, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useState } from "react";
import { RoomDetail } from "./components";

export const RoomPreview = ({ room }: { room: RoomDMaxInfoResponse }) => {
    // const { onNavigate } = useNewNavigate();
    const [currentIdx, setCurrentIdx] = useState(0);
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();
    const { rooms } = { ...room };

    const nextSlide = () => {
        if (rooms) setCurrentIdx((prev) => (prev === (rooms.length as number) - 1 ? 0 : prev + 1));
    };
    const prevSlide = () => {
        if (rooms) setCurrentIdx((prev) => (prev === 0 ? (rooms.length as number) - 1 : prev - 1));
    };

    return (
        <Center position="relative" width="100%">
            <Center as="section">
                <Flex
                    position="relative"
                    flexDir={isMobile ? "column" : "row"}
                    // eslint-disable-next-line no-nested-ternary
                    gap={isMobile ? "16px" : isLaptop ? "64px" : "80px"}
                    p={isMobile ? "0 20px" : "0"}
                >
                    <Box
                        zIndex="1"
                        position="relative"
                        maxW="680px !important"
                        w="100%"
                        // eslint-disable-next-line no-nested-ternary
                        h={isMobile ? "224px" : isLaptop ? "auto" : "800px"}
                    >
                        {rooms.map((room, index) => (
                            <MotionImg
                                position="absolute"
                                key={room.room_idx}
                                w="100%"
                                h="100%"
                                bg={
                                    room.imgList[0]
                                        ? `url(${room.imgList[0].img_URL})no-repeat center/cover`
                                        : "gray.100"
                                }
                                initial={{ opacity: index === currentIdx ? 1 : 0 }}
                                animate={{
                                    opacity: index === currentIdx ? 1 : 0,
                                    transition: { duration: 0.7, ease: "easeIn" },
                                }}
                            />
                        ))}
                    </Box>
                    <Flex
                        zIndex="1"
                        flex="1"
                        h={isLaptop ? "auto" : "1168px"}
                        flexDir="column"
                        justifyContent="space-between"
                        alignItems="flex-end"
                    >
                        <RoomDetail rooms={rooms} currentIdx={currentIdx} nextSlide={nextSlide} prevSlide={prevSlide} />
                        {!isLaptop && (
                            <Box position="relative" maxW="720px" w="100%" h="538px">
                                {rooms.map((room, index) => (
                                    <MotionImg
                                        position="absolute"
                                        key={room.room_idx}
                                        w="100%"
                                        h="100%"
                                        bg={
                                            room.imgList[1]
                                                ? `url(${room.imgList[1].img_URL})no-repeat center/cover`
                                                : "gray.100"
                                        }
                                        initial={{ opacity: index === currentIdx ? 1 : 0 }}
                                        animate={{
                                            opacity: index === currentIdx ? 1 : 0,
                                            transition: { duration: 0.7, ease: "easeIn" },
                                        }}
                                    />
                                ))}
                            </Box>
                        )}
                    </Flex>
                    {!isLaptop && (
                        <Box
                            zIndex="0"
                            position="absolute"
                            left="50%"
                            bottom="108px"
                            w="656px"
                            h="496px"
                            transform="translateX(-50%)"
                            bg="#3b6c8d"
                        />
                    )}
                </Flex>
            </Center>
        </Center>
    );
};

const MotionImg = chakra(motion.div);
